import React from "react";
import { useState, useEffect } from "react";
import Points from "./Points";
import Transactions from "./Transactions";
import Coupons from "./Coupons";
import Profile from "./Profile";

const MyDetails = () => {

  const [showProfile, setShowProfile] = useState(false);

  function onMyProfile() {
    setShowProfile(true);
  }

  function onLogout(){

    
  }

  return (
    <div className="container">

      <div className="content">
        <Points userId={sessionStorage.getItem("userId")} />

      </div>

      <div className="content">
        
        <Transactions userId={sessionStorage.getItem("userId")} />    

      </div>

      {/* <div className="content">
        
        <Coupons userId={sessionStorage.getItem("userId")} />    

      </div> */}

    </div>
  );
};

export default MyDetails;
